import type { FunctionComponent } from 'react';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { HeaderTitle } from '../../../components/HeaderTitle/HeaderTitle';

export const SearchLandingPageHeaderTitleWithData: FunctionComponent = () => {
  const cachedQuery = useSearchLandingPageBySlugQuery();

  if (!cachedQuery) return null;

  const {
    overlineV2: overline = '',
    title = '',
    subtitleV2 = '',
  } = cachedQuery?.header?.title ?? {};

  return <HeaderTitle overline={overline} title={title} subtitle={subtitleV2} />;
};
